var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinnerDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "16px",
    height: "16px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    color: "transparent",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 40,
    rx: 10,
    ry: 10,
    width: 20,
    height: 20,
    "transform-origin": "85 45",
    fill: "#00b5e9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#00b5e9;#00000000",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    additive: "sum",
    from: "1 1",
    to: "0.65 0.65",
    begin: -1,
    dur: "1s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68.2842712474619,
    y: 68.2842712474619,
    rx: 10,
    ry: 10,
    width: 20,
    height: 20,
    "transform-origin": "73.2842712474619 73.2842712474619",
    fill: "#00b5e9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#00b5e9;#00000000",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.875s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    additive: "sum",
    from: "1 1",
    to: "0.65 0.65",
    begin: -0.875,
    dur: "1s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 80,
    rx: 10,
    ry: 10,
    width: 20,
    height: 20,
    "transform-origin": "45 85",
    fill: "#00b5e9;#00000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#00b5e9;#0000000",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.75s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    additive: "sum",
    from: "1 1",
    to: "0.65 0.65",
    begin: -0.75,
    dur: "1s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.7157287525381,
    y: 68.2842712474619,
    rx: 10,
    ry: 10,
    width: 20,
    height: 20,
    "transform-origin": "16.7157287525381 73.2842712474619",
    fill: "#00b5e9;#00000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#00b5e9;#00000000",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.625s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    additive: "sum",
    from: "1 1",
    to: "0.65 0.65",
    begin: -0.625,
    dur: "1s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 40,
    rx: 10,
    ry: 10,
    width: 20,
    height: 20,
    "transform-origin": "5 45",
    fill: "#00b5e9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#00b5e9;#00000000",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    additive: "sum",
    from: "1 1",
    to: "0.65 0.65",
    begin: -0.5,
    dur: "1s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.7157287525381,
    y: 11.7157287525381,
    rx: 10,
    ry: 10,
    width: 20,
    height: 20,
    "transform-origin": "16.7157287525381 16.7157287525381",
    fill: "#00b5e9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#00b5e9;#00000000",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.375s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    additive: "sum",
    from: "1 1",
    to: "0.65 0.65",
    begin: -0.375,
    dur: "1s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 0,
    rx: 10,
    ry: 10,
    width: 20,
    height: 20,
    "transform-origin": "45 5",
    fill: "#00b5e9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#00b5e9;#00000000",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.25s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    additive: "sum",
    from: "1 1",
    to: "0.65 0.65",
    begin: -0.25,
    dur: "1s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68.2842712474619,
    y: 11.7157287525381,
    rx: 10,
    ry: 10,
    width: 20,
    height: 20,
    "transform-origin": "73.2842712474619 16.7157287525381",
    fill: "#00b5e9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#00b5e9;#00000000",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.125s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    additive: "sum",
    from: "1 1",
    to: "0.65 0.65",
    begin: -0.125,
    dur: "1s",
    repeatCount: "indefinite"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerDark);
export default __webpack_public_path__ + "static/media/spinner_dark.a2bfdeb9245a51f7199434d2376f8912.svg";
export { ForwardRef as ReactComponent };